import api from "../../../../utils/api";
import { getRoleNameArr } from "../../../../utils/helpers/getDataArray";

const RoleApi = {
  // get all roles
  async fetchRoles() {
    const response = await api.get("/role");
    const roleNameArr = getRoleNameArr(response?.data?.data);
    localStorage.setItem("roleNameArr", JSON.stringify(roleNameArr));
    return { data: response?.data };
  },

  // add a role
  async addRole(roleData) {
    const response = await api.post("/role", roleData);
    return response?.data;
  },

  // update a role
  async updateRole(data) {
    const response = await api.patch(`/role/${data.id}`, data.updatedRoleData);
    return response.data;
  },
};

export default RoleApi;
